import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../../config/constants';

import {
  WysiwygField,
  ImageWithIllustration,
  FormattedLink,
} from '../../../components';

import ParagraphText from '../Text';

import './style.scss';

const ParagraphTextImage = ({ entity, className, withIndent }) => {
  // Check if we have an image and switch to
  // a paragraph without an image if needed.
  if (entity.get('field_image').size < 1) {
    return <ParagraphText entity={entity} />;
  }

  // const large = entity.getIn(['field_large_display', 0, 'value']);
  const imagePostion = entity.getIn(['field_image_position', 0, 'value']);
  const link = entity.get('field_link');

  return (
    <div className={c('Paragraph', 'ParagraphTextImage', { 'u-indent': withIndent }, className)}>
      <div className={c('row', { 'u-flipped--reversed': imagePostion === 'right' })}>
        {entity.get('field_text').size > 0 ? (
          <div className={c('col-md-6', 'content', 'offset-md-1', 'u-margin--top--5', 'js-parallax', { 'offset-lg-0': imagePostion === 'right' })}>
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
            <WysiwygField
              property="schema:text"
              html={entity.getIn(['field_text', 0, 'processed'])}
            />
            <FormattedLink link={link} />
          </div>
        ) : (
          <div className="col-md-12">
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
          </div>
        )}
        <div
          className={c('image', 'js-parallax', {
            'offset-lg-1': imagePostion === 'right' && entity.get('field_text').size > 0,
            'col-md-5': entity.get('field_text').size > 0,
            'col-md-12': !entity.get('field_text').size > 0,
          })}
        >
          <ImageWithIllustration
            image={entity.getIn(['field_image', 0], Immutable.Map())}
            crops={Immutable.Map({
              [SCREEN_MOBILE]: 'cropped_standard_medium_viewport',
              [SCREEN_NORMAL]: 'crop_standard',
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default ParagraphTextImage;
